import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { NzModalRef, NzModalService } from 'ng-zorro-antd';
import { ReadyLimitTransferComponent } from './ready-limit-transfer/ready-limit-transfer.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentMethod } from '../../../../model/payment-method';
import { PaymentModel } from '../../../../model/payment.model';
import { UserDto } from '../../../../model/user/user-dto';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SubjectService } from '../../../../shared/services/subject/subject.service';
import { CvvInfoComponent } from '../../../../shared/notification/cvv-info/cvv-info.component';
import { TextService } from '../../../../shared/services/text.service';
import { NetmeraService } from "../../../../shared/services/netmera-service";
import { KartEkle } from "../../../../model/netmera-events/kart-ekle";

@Component({
  selector: 'pa-payment-method-selection',
  templateUrl: './payment-method-selection.component.html',
  styleUrls: ['./payment-method-selection.component.scss']
})
export class PaymentMethodSelectionComponent implements OnInit {

  @Input() paymentModelInformation: PaymentModel;
  @Input() user: UserDto;
  @Output() carouselChange = new EventEmitter();
  @Output() cvvPassByValue = new EventEmitter();
  @ViewChild('carousel', {static: true}) carousel: NgbCarousel;
  firstImage = Object.create({
    current: 'ngb-slide-0'
  });
  paymentInformation: PaymentMethod;
  tplModal: NzModalRef;
  textService: TextService;
  showCvv: boolean = false;
  showCardAddButton: boolean = false;
  trackingId: string;
  paymentMethodSelectionForm = new FormGroup({
    cvv: new FormControl('')
  });

  constructor(private router: Router, private route: ActivatedRoute, private modalService: NzModalService, private subjectService: SubjectService,
              private changeDetectionRef: ChangeDetectorRef, textService: TextService, private netmeraService: NetmeraService, private kartEkle: KartEkle) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
    });
    this.findCarouselIndex(this.firstImage);
    this.checkCvv();
    this.checkCardAddButton();
  }

  findCarouselIndex(event) {
    const imageIndex = Number(event.current.replace('ngb-slide-', ''));
    this.paymentInformation = this.paymentModelInformation?.paymentMethod != null && this.paymentModelInformation.paymentMethod.length > 0 ?
      this.paymentModelInformation?.paymentMethod[imageIndex] : null;
    this.paymentMethodSelectionForm.reset();
    this.checkCvv();
    this.carouselChange.emit(this.paymentInformation);
  }

  checkCvv() {
    this.subjectService.amountSubject$.subscribe(amount => {
      if (!!amount) {
        if (this.paymentInformation?.paymentMethodType === 'CREDIT_CARD' && this.user?.merchantCvvRequired && amount >= Number(this.user?.merchantCvvAmount)) {
          this.showCvv = true;
          this.paymentMethodSelectionForm.controls["cvv"].setValidators([Validators.required, Validators.minLength(3)]);
          this.changeDetectionRef.detectChanges();
        } else if (this.paymentInformation?.paymentMethodType === 'CREDIT_CARD' && this.user?.merchantCvvRequired && amount < Number(this.user?.merchantCvvAmount)) {
          this.showCvv = false;
          this.paymentMethodSelectionForm.controls["cvv"].setValidators([Validators.required, Validators.minLength(3)]);
          this.changeDetectionRef.detectChanges();
        }
      } else {
        if (this.paymentInformation?.paymentMethodType === 'CREDIT_CARD' && this.user?.merchantCvvRequired && Number(this.user?.firstAmount) >= Number(this.user?.merchantCvvAmount)) {
          this.showCvv = true;
          this.paymentMethodSelectionForm.controls["cvv"].setValidators([Validators.required, Validators.minLength(3)]);
          this.changeDetectionRef.detectChanges();

        }
      }
    });
  }

  checkCardAddButton() {
    this.showCardAddButton = this.paymentModelInformation.creditCardEnabled;
  }

  addCardRouter() {
    this.netmeraService.pushEvent(this.kartEkle.setEventObject("KartEkle"));
    this.router.navigate(['/payment/add-card', this.trackingId]);
  }

  //Dcb üzerindeki emoney Kısmı
  checkEMoney(paymentInformation: PaymentMethod) {
    let eMoney;
    if (paymentInformation != null && paymentInformation.paymentMethodType === "DCB") {
      eMoney = Number(paymentInformation.emoneys != null && paymentInformation.emoneys.length != 0 ? paymentInformation.emoneys[0].amount : null);
    }
    return eMoney;
  }

  changeEvent(event: any) {
      this.cvvPassByValue.emit(event);
  }

  createCvvModal(): void {
    (document.getElementById("cvvInput") as HTMLSelectElement).disabled = true;
    this.tplModal = this.modalService.create({
      nzClassName:'cvvModal',
      nzWrapClassName: 'button:focus',
      nzContent: CvvInfoComponent,
      nzMaskClosable: true,
      nzClosable: true,
      nzFooter: null,
      nzOnCancel: ()=> {(document.getElementById("cvvInput") as HTMLSelectElement).disabled = false;},
      nzStyle: {
        width: '327px',
        height: '275px',
        'border-radius': '14px',
        'box-shadow': '0 0 15px 0 rgba(0, 0, 0, 0.25)',
        'background-color': '#ffffff'
      },
      nzComponentParams: {trackingId: this.trackingId}
    });
  }

  //Hazır Para Transferi İçin Gerekli.
  readyTransferLimitClick() {
    this.modalService.create({
      nzContent: ReadyLimitTransferComponent,
      nzMaskClosable: true,
      nzClosable: true,
      nzFooter: null,
      nzComponentParams: {card: this.paymentInformation}
    });
  }
}
